import type { ProfessionalTypeEnum } from '@gql/graphql';
import type { LocationDescriptor } from 'history';

export interface LocationLinksSection {
  title: string;
  links: LocationLinksLink[];
}

export interface LocationLinksLink {
  to: LocationDescriptor;
  label: string;
}

export interface LocationLinksPageData {
  sections: LocationLinksSection[];
  proType: ProfessionalTypeEnum;
}

export interface LocationLinksPageProps extends LocationLinksPageData {}
